export const getMotMileageWarning = (formData) => {
  const last = parseInt(formData.mot_last_mileage, 10);
  const current = parseInt(String(formData.vehicle_mileage || '').replace(/\D/g, ''), 10);
  if (!last || !current || current >= last) return '';
  return `Entered mileage ${current.toLocaleString('en-GB')} is lower than the last MOT reading of ${last.toLocaleString('en-GB')} mi (${formData.mot_last_date || 'date unknown'})`;
};
